import { Component, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ContactsDialogConfirmContactDeleteComponent } from '../contact-confirm-delete-modal/contact-confirm-delete-modal.component';
import { SharedService } from '../../../layouts/shared-service';
import { AppDialogWrapperService } from '../../../ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

export interface NewContactDialogData {
    oid: number;

    firstName: string;
    lastName: string;
    title: string;
    email: string;
    phone: string;
    extension: string;
    mobile: string;
    fax: string;
    address: string;
    city: string;
    state: string;
    country: string;
    primary: boolean;
    copyAlerts: boolean;
}

@Component({
    selector: 'app-contacts-dialog-new-contact',
    styleUrls: ['./contacts-edit-modal.component.scss'],
    templateUrl: './contacts-edit-modal.component.html',
})
export class ContactsDialogNewContactComponent {
    isFboLogin: boolean = this.sharedService.isFboLogin;

    // Masks
    phoneMask = '(000) 000-0000';
    prefix = '+1 ';

    // For AppDialogWrapperService pattern
    private _data: NewContactDialogData;
    
    get data(): NewContactDialogData {
        return this._data;
    }
    
    set data(value: NewContactDialogData) {
        this._data = value;
    }

    dialogRef: { close: (result?: any) => void };

    constructor(
        private appDialogWrapperService: AppDialogWrapperService,
        private sharedService: SharedService,
        @Optional() @Inject(MAT_DIALOG_DATA) data?: NewContactDialogData,
        @Optional() @Inject(MatDialogRef) dialogRef?: MatDialogRef<any>
    ) {
        // Backwards compatibility: support both injection patterns
        if (data) {
            this._data = data;
        }
        if (dialogRef) {
            this.dialogRef = dialogRef;
        }
    }

    // Public Methods
    public onCancelClick(): void {
        this.dialogRef.close('cancel');
    }

    public ConfirmDelete(data) {
        const dialogWrapper = this.appDialogWrapperService.open<any>({
            title: 'Delete Contact',
            component: ContactsDialogConfirmContactDeleteComponent,
            data: data,
            width: '450px'
        });

        dialogWrapper.afterClosed().subscribe((result) => {
            if (result === 'cancel') {
            } else if (result && result.contactId) {
                result.toDelete = true;
                this.dialogRef.close(result);
            }
        });
    }
}
function provideNgxMask(): import("@angular/core").Provider {
    throw new Error('Function not implemented.');
}

